
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-delivery/campaigns",
      function () {
        return require("private-next-pages/native-delivery/campaigns.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-delivery/campaigns"])
      });
    }
  